// extracted by mini-css-extract-plugin
export default {"primary":"styles_primary__l-rfE","secondary":"styles_secondary__o4sap","fixedRight":"styles_fixedRight__Yfa+r"};